// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__2o5_d","title":"Title_title__mP2R7","date":"Title_date__Kt9xo"};